import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../Components/Header";
import { useParams } from "react-router-dom";
import "../Components/DoctoeAppointment.css";
import {
  MDBBadge,
  MDBCol,
  MDBContainer,
  MDBRow,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBBtn,
} from "mdb-react-ui-kit";
import DataTable from "react-data-table-component";
import {
  Nav,
  NavItem,
  NavLink,
  Spinner
} from 'reactstrap';
import { Button, Modal, Table } from "react-bootstrap";
import { BASE_URL } from "../config";

export default function DoctorAppointment() {
  const navigate = useNavigate();
  const [doctorAppointment, setDoctorAppointment] = useState([]);
  const [selectedTab, setSelectedTab] = useState('active');

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [totalRows, setTotalRows] = useState(0);


  const { id } = useParams();

  const [loading, setLoading] = useState(true);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [prescriptionData, setPrescriptionData] = useState(null);
  const [consultationLoading, setConsultationLoading] = useState(false);

  const fetchDoctorAppointments = useCallback(async () => {
    setLoading(true);
    try {
      const url =
        selectedTab === "active"
          ? `${BASE_URL}DoctorAppointment?id=${id}`
          : `${BASE_URL}PreviousDoctorAppointment?id=${id}&pageNumber=${page}&pageSize=${pageSize}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      });

      const data = await response.json();
      console.log("Fetched data:", data);

      if (response.ok) {
        setDoctorAppointment(data.getAppointmentScheduleDetail || []);
        if (selectedTab === "inactive") {
          setTotalRows(data.totalCount || 0); // Assuming API returns totalCount
        }
      } else {
        alert(data.message || "Failed to fetch appointments");
      }
    } catch (error) {
      console.error("Error fetching appointments:", error);
    } finally {
      setLoading(false);
    }
  }, [id, selectedTab, page, pageSize]);




  const calculateRemainingTime = (appointmentDate, appointmentTime) => {
    const now = new Date();
    const timePart = appointmentTime.slice(11); // Extract time, e.g., '15:00:00'
    const appointmentDateTime = new Date(now.toDateString() + " " + timePart);

    const isToday =
      new Date(appointmentDate).toDateString() === now.toDateString();

    // Start time is at appointment time
    const startTime = appointmentDateTime;
    // End time is 20 minutes after the appointment time
    const endTime = new Date(appointmentDateTime.getTime() + 20 * 60000);

    // Check if appointment is closed
    if (now > endTime) {
      return { timeRemaining: "Appointment Closed", totalSeconds: 0 };
    }

    // Check if appointment has started
    if (now < startTime) {
      const timeDifference = startTime - now;
      const totalSeconds = Math.floor(timeDifference / 1000);
      const hoursRemaining = Math.floor(totalSeconds / 3600);
      const minutesRemaining = Math.floor((totalSeconds % 3600) / 60);
      const secondsRemaining = totalSeconds % 60;

      const remainingTime = `${hoursRemaining}h ${minutesRemaining}m ${secondsRemaining}s`;
      return { timeRemaining: remainingTime, totalSeconds, isUpcoming: true };
    } else {
      // Appointment is currently in progress
      const timeDifference = endTime - now;
      const totalSeconds = Math.floor(timeDifference / 1000);
      const hoursRemaining = Math.floor(totalSeconds / 3600);
      const minutesRemaining = Math.floor((totalSeconds % 3600) / 60);
      const secondsRemaining = totalSeconds % 60;

      const remainingTime = `${hoursRemaining}h ${minutesRemaining}m ${secondsRemaining}s`;
      return { timeRemaining: remainingTime, totalSeconds, isUpcoming: false };
    }
  };

  const formatAppointmentDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", options);
  };

  const formatAppointmentTime = (timeString) => {
    const timePart = timeString.split("T")[1];
    const [hours, minutes] = timePart.split(":");
    let hoursInt = parseInt(hours, 10);
    let period = "AM";

    if (hoursInt >= 12) {
      period = "PM";
      if (hoursInt > 12) {
        hoursInt -= 12;
      }
    }

    if (hoursInt === 0) {
      hoursInt = 12;
    }

    return `${hoursInt}:${minutes} ${period}`;
  };

  const [currentTime, setCurrentTime] = useState(new Date());


  // useEffect(() => {
  //   fetchDoctorAppointments();
  //   const interval = setInterval(() => {
  //     if (selectedTab === "active") {
  //       fetchDoctorAppointments();
  //     }
  //   }, 60000);

  //   return () => clearInterval(interval);
  // }, [fetchDoctorAppointments, selectedTab]);

  useEffect(() => {
    fetchDoctorAppointments();

    // Refresh every minute from API
    const fetchInterval = setInterval(() => {
      if (selectedTab === "active") {
        fetchDoctorAppointments();
      }
    }, 60000);

    // Re-render every second
    const tickInterval = setInterval(() => {
      setCurrentTime(new Date()); // Causes re-render every second
    }, 1000);

    return () => {
      clearInterval(fetchInterval);
      clearInterval(tickInterval);
    };
  }, [fetchDoctorAppointments, selectedTab]);



  const fetchPrescriptionByConsultId = async (consultId) => {
    setShow(true);
    setConsultationLoading(true);
    try {
      const response = await fetch(`${BASE_URL}GetConsultationById?consultationId=${consultId}`, {
        method: "GET",
        headers: {
          Accept: "*/*",
        },
      });
      const data = await response.json();
      if (response.ok && data.responseCode === "0000") {
        setPrescriptionData(data);
      } else {
        alert(data.message || "Failed to load consultation details");
      }
    } catch (error) {
      console.error("Error fetching consultation:", error);
      alert("Error fetching consultation");
    } finally {
      setConsultationLoading(false);
    }
  };



  const baseColumns = [
    {
      name: <span className="fw-bold">Patient Name</span>,
      selector: (row) => row.patientName,
      sortable: true,
    },
    // {
    //   name: <span className="fw-bold">Patient No</span>,
    //   selector: (row) => row.patientNo,
    //   sortable: true,
    // },
    {
      name: <span className="fw-bold">Appointment No</span>,
      selector: (row) => row.appointmentNo,
      sortable: true,
    },
    {
      name: <span className="fw-bold">Appointment Date</span>,
      selector: (row) => formatAppointmentDate(row.appointmentDate),
      sortable: true,
    },
    {
      name: <span className="fw-bold">Appointment Time</span>,
      selector: (row) => formatAppointmentTime(row.appointmentTime),
      sortable: true,
    },
    {
      name: <span className="fw-bold">Status</span>,
      selector: (row) => {
        const { isUpcoming, totalSeconds, timeRemaining } = calculateRemainingTime(row.appointmentDate, row.appointmentTime);

        let displayStatus = row.status || "N/A";

        if (row.status === "Booked" && timeRemaining !== "Appointment Closed") {
          if (!isUpcoming && totalSeconds <= 1200) {
            displayStatus = "Active";
          }
        }

        return (
          <MDBBadge color="success" pill>
            {displayStatus}
          </MDBBadge>
        );
      },
      sortable: true,
    }
  ];

  // Conditional columns
  const timeRemainingColumn = {
    name: <span className="fw-bold">Time Remaining</span>,
    selector: (row) =>
      calculateRemainingTime(row.appointmentDate, row.appointmentTime)
        .timeRemaining,
    sortable: true,
  };

  const actionColumn = {
    name: <span className="fw-bold">Action</span>,
    selector: (row) => {
      const { totalSeconds, timeRemaining, isUpcoming } =
        calculateRemainingTime(row.appointmentDate, row.appointmentTime);

      if (timeRemaining === "Appointment Closed") {
        return null;
      }

      if (isUpcoming && totalSeconds <= 1200) {
        return (
          <MDBBtn color="primary" className="btn_primary px-1" size="sm" disabled>
            Waiting
          </MDBBtn>
        );
      }

      const isDisabled = totalSeconds > 1200;

      return (
        <MDBBtn
          color="primary"
          className="btn_primary px-1"
          size="sm"
          disabled={isDisabled}
          onClick={() =>
            handleJoinCall(row.appointmentNo, row.doctorEmail, row.patientEmail)
          }
        >
          {isDisabled ? "Waiting" : "Join Call"}
        </MDBBtn>
      );
    },
    sortable: false,
  };

  const prevActionColumn = {
    name: <span className="fw-bold">Action</span>,
    selector: (row) => {
      // Render a button only if consultId is not 0 or null
      if (row.consultId && row.consultId !== 0) {
        return (
          <MDBBtn
            color="primary"
            className="btn_primary px-1 w-100"
            size="sm"
            onClick={() => fetchPrescriptionByConsultId(row.consultId)}
          >
            View Prescription
          </MDBBtn>
        );
      }
      return null;
    },
    sortable: false,
    width: '152px',
  };

  // Final columns array
  const columns = selectedTab === "inactive"
    ? [prevActionColumn, ...baseColumns]
    : [actionColumn, ...baseColumns, timeRemainingColumn];


  const handleJoinCall = (appointmentNo, doctorEmail, patientEmail) => {

    const session = JSON.parse(sessionStorage.getItem("user"));

    const loginUserId = session.UserId;
    console.log("Login User ID:", loginUserId);

    navigate(`/incoming/?channel=${doctorEmail}&doctorId=${loginUserId}&senderEmail=${patientEmail}`);
    // console.log(`Joining call for appointment: ${appointmentNo}`);
    // Add your logic here (e.g., navigate to a call page, open a video call, etc.)
  };

  const prepareDataForTable = () => {
    return doctorAppointment.map((schedule) => {
      const { timeRemaining, totalSeconds, isUpcoming } =
        calculateRemainingTime(
          schedule.appointmentDate,
          schedule.appointmentTime
        );

      return {
        patientName: schedule.patientName || "N/A",
        patientNo: schedule.patientNo || "N/A",
        appointmentNo: schedule.appointmentNo || "N/A",
        appointmentDate: schedule.appointmentDate || "N/A",
        appointmentTime: schedule.appointmentTime || "N/A",
        status: schedule.status || "N/A",
        timeRemaining: timeRemaining,
        blink: isUpcoming && totalSeconds <= 1200, // Blink if upcoming and less than or equal to 20 minutes
        blinkActive:
          schedule.status === "Booked" &&
          !isUpcoming &&
          totalSeconds <= 1200 &&
          timeRemaining !== "Appointment Closed",
        doctorEmail: schedule.doctorEmail || "N/A",
        patientEmail: schedule.patientEmail || "N/A",
        consultId: schedule.consultId || null,
      };
    });
  };


  return (
    <MDBContainer fluid className="container-fluid py-1">

      <Header />
      <MDBRow className="d-flex justify-content-center align-items-center h-45">
        <MDBCol xs="12" sm="12" md="12" lg="12">
          <MDBCard
            className="card-registration card-registration-2 mt-3"
            style={{ borderRadius: "12px" }}
          >
            <MDBCardHeader className="text-center bg_primary text-white border-0">
              <h5 className="fw-bold mb-1">Appointments</h5>
            </MDBCardHeader>
            {
              loading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                  <Spinner size="lg" />
                </div>
              ) : (
                <>
                  <Nav tabs className='bg_light p-1'>
                    <NavLink
                      className={selectedTab === 'active' ? 'active' : ''}
                      onClick={() => setSelectedTab('active')}
                    >
                      Today
                    </NavLink>

                    <NavLink
                      className={selectedTab === 'inactive' ? 'active' : ''}
                      onClick={() => setSelectedTab('inactive')}
                    >
                      Previous
                    </NavLink>
                  </Nav>
                  <MDBCardBody className="p-0">
                    <DataTable
                      columns={columns}
                      data={prepareDataForTable()}
                      pagination
                      paginationServer={selectedTab === "inactive"}
                      paginationTotalRows={totalRows}
                      paginationDefaultPage={page}
                      paginationPerPage={pageSize}
                      onChangePage={(newPage) => setPage(newPage)}
                      onChangeRowsPerPage={(newPageSize, newPage) => {
                        setPageSize(newPageSize);
                        setPage(newPage);
                      }}
                      responsive
                      highlightOnHover
                      pointerOnHover
                      conditionalRowStyles={[
                        {
                          when: (row) => row.blinkActive,
                          style: {
                            backgroundColor: "#ffcccb", // Light red for waiting
                            animation: "blink-red 1s infinite",
                          },
                        },
                        {
                          when: (row) => row.blink,
                          style: {
                            backgroundColor: "#9fedbe", // Light green for active
                            animation: "blink-green 1s infinite",
                          },
                        },
                      ]}
                    />
                  </MDBCardBody>
                </>
              )
            }

          </MDBCard>
        </MDBCol>
      </MDBRow>
      <Modal show={show} onHide={handleClose} centered size="lg" scrollable>
        <Modal.Header closeButton className="bg_primary text-white">
          <Modal.Title>Prescription Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {consultationLoading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
              <Spinner size="lg" />
            </div>
          ) : prescriptionData ? (
            <>
              <p><strong>Doctor:</strong> {prescriptionData.consultData?.doctorName}</p>
              <p><strong>Patient:</strong> {prescriptionData.consultData?.patientName}</p>
              <p><strong>Date:</strong> {prescriptionData.consultData?.consultationDate}</p>
              <p><strong>Diagnosis:</strong> {prescriptionData.consultData?.diagnosis}</p>
              <p><strong>Remarks:</strong> {prescriptionData.consultData?.remarks}</p>
              <p><strong>Tests:</strong> {prescriptionData.consultData?.tests}</p>

              <h6 className="mt-3 fw-bold">Medicine Detail:</h6>
              <Table bordered responsive>
                <thead className="bg_light">
                  <tr>
                    <th>Medicine</th>
                    <th>Morning</th>
                    <th>Night</th>
                    <th>Days</th>
                    <th>Notes</th>
                  </tr>
                </thead>
                <tbody>
                  {prescriptionData.prescrib.map((item, index) => (
                    <tr key={index}>
                      <td>{item.medicineName}</td>
                      <td>{item.morning}</td>
                      <td>{item.night}</td>
                      <td>{item.noOfDays}</td>
                      <td>{item.additionalNotes}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          ) : (
            <p>No prescription found.</p>
          )}
        </Modal.Body>
      </Modal>

    </MDBContainer>
  );
}